var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#282828",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 7.33283H0V1.99986C0 1.46947 0.210714 0.960793 0.585786 0.585746C0.960859 0.210699 1.46957 0 2 0L7.33333 0V7.33283ZM1.33333 5.99959H6V1.33324H2C1.82319 1.33324 1.65362 1.40348 1.5286 1.52849C1.40357 1.65351 1.33333 1.82306 1.33333 1.99986V5.99959Z",
    fill: "current-color"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0013 7.33283H8.66797V0H14.0013C14.5317 0 15.0404 0.210699 15.4155 0.585746C15.7906 0.960793 16.0013 1.46947 16.0013 1.99986V7.33283ZM10.0013 5.99959H14.668V1.99986C14.668 1.82306 14.5977 1.65351 14.4727 1.52849C14.3477 1.40348 14.1781 1.33324 14.0013 1.33324H10.0013V5.99959Z",
    fill: "current-color"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 16.0001H2C1.46957 16.0001 0.960859 15.7894 0.585786 15.4143C0.210714 15.0393 0 14.5306 0 14.0002L0 8.66724H7.33333V16.0001ZM1.33333 10.0005V14.0002C1.33333 14.177 1.40357 14.3466 1.5286 14.4716C1.65362 14.5966 1.82319 14.6668 2 14.6668H6V10.0005H1.33333Z",
    fill: "current-color"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0013 16.0001H8.66797V8.66724H16.0013V14.0002C16.0013 14.5306 15.7906 15.0393 15.4155 15.4143C15.0404 15.7894 14.5317 16.0001 14.0013 16.0001ZM10.0013 14.6668H14.0013C14.1781 14.6668 14.3477 14.5966 14.4727 14.4716C14.5977 14.3466 14.668 14.177 14.668 14.0002V10.0005H10.0013V14.6668Z",
    fill: "current-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.e2f0b3b108450231cbbb76cd0438ee85.svg";
export { ForwardRef as ReactComponent };